import axios from 'axios';
import { addAuthorizationHeader } from './resources/auth';

export function createApiClient(config) {
  const headers = config?.headers || {};
  headers['X-Requested-With'] = 'XMLHttpRequest';
  const apiClient = axios.create({ ...config, headers });
  apiClient.interceptors.request.use(addAuthorizationHeader);
  return apiClient;
}

export default createApiClient();
